import style from "./Navigation.module.scss";
import { useLocation } from "react-router-dom";
import {FC} from 'react'
import { Steps } from 'antd'

export type NavigationItem = {
  title: string
  description?: string
  subtitle?: string
}

export type NavigationCurrent = {
  path: string
  current: number
};

interface IProps {
  items: NavigationItem[]
  current: NavigationCurrent[]
}

export const Navigation: FC<IProps> = ({ items, current }) => {
  const location = useLocation();

  // Сортируем пути по длине (от длинного к короткому) для правильного приоритета
  const sortedCurrent = [...current].sort((a, b) => b.path.length - a.path.length);
  const step = sortedCurrent.find(i => location.pathname.startsWith(i.path))

  return (
    <Steps
      className={style.step}
      current={step?.current}
      items={items}
    />
  );
}
